export const iconEmojiSizeBig = 32;

export const fontBody = '\'Lato\', sans-serif';
export const fontHeadings = '\'Fjalla One\', sans-serif';
export const fontHeadingsBis = '\'Montserrat\', sans-serif';
